module.exports = __webpack_public_path__ + "assets/img/block-left-20adc6ed.png";